import { useParams } from 'react-router-dom';
import ResourcePage from './ResourcePage';
import { resources } from './data';
import NotFound from '../NotFound';

export default function ResourceRoute() {
  const { slug } = useParams<{ slug: string }>();

  if (!slug || !resources[slug]) {
    return <NotFound />;
  }

  return <ResourcePage data={resources[slug]} />;
}
